import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "@/data/services";

const ContentContext = createContext(DEFAULT_CONTENT);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((res) => setContent(res.data))
      .catch(() => {});
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
